import heroBg from '../../../assets/hero-bg.jpg';
import React from 'react';
import { Box, Button, Container, Heading, Text, VStack } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';

const HomeHero: React.FC = () => {
  return (
    <Box
      as="section"
      bgImage={`url(${heroBg})`}
      bgSize="cover"
      backgroundPosition="center"
      bgRepeat="no-repeat"
      color="white"
      boxShadow="inset 0 0 0 100vw rgba(0,0,0,0.5)"
      py={{ base: 16, md: 24 }}
    >
      <Container maxW="6xl">
        <VStack align="flex-start" maxW="3xl">
          <Heading as="h1" size="3xl" lineHeight="1.05">
            Kreatywne korepetycje
            <Box as="span" display="block">
              w nowoczesnym wydaniu
            </Box>
          </Heading>

          <Text fontSize={{ base: "xl", md: "2xl" }} maxW="2xl" opacity={0.9}>
            Rozbudzamy ciekawość i pasję do nauki
          </Text>

          <NavLink to={`/zapisy`}>
            <Button size="lg" colorPalette='brand' color="white" rounded="md" px={8}>
              Zapisz się
            </Button>
          </NavLink>
        </VStack>
      </Container>
    </Box>
  );
};

export default HomeHero;
